import { __awaiter } from "tslib";
import { useCallback, useRef, useState } from 'react';
const DEFAULT_MODAL_STATE = { open: false };
/** Gives you props and methods used to create and control a Modal */
export default function useModalProps(
/** Callback fires when the modal is completed */
onComplete) {
    const [state, setState] = useState(DEFAULT_MODAL_STATE);
    const resolveRef = useRef();
    const shutModal = useCallback((result) => {
        var _a;
        setState(DEFAULT_MODAL_STATE);
        (_a = resolveRef.current) === null || _a === void 0 ? void 0 : _a.call(resolveRef, result);
        resolveRef.current = undefined;
    }, []);
    const handleClose = useCallback(() => shutModal(undefined), [shutModal]);
    const handleSubmit = useCallback((submittedValue) => __awaiter(this, void 0, void 0, function* () {
        const result = yield onComplete(submittedValue);
        shutModal(result);
        return result;
    }), [onComplete, shutModal]);
    const handleSubmitValue = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        const result = yield onComplete(state.value);
        shutModal(result);
        return result;
    }), [onComplete, state.value, shutModal]);
    const modalProps = {
        onPatch: useCallback((patch) => setState((old) => {
            const patchedValue = Object.assign(Object.assign({}, old.value), patch);
            return Object.assign(Object.assign({}, old), { value: patchedValue });
        }), []),
        onChange: useCallback((newValue) => {
            setState((old) => (Object.assign(Object.assign({}, old), { value: newValue })));
        }, []),
        onCancel: handleClose,
        onClose: handleClose,
        visible: state.open,
        value: state.value,
        initialValue: state.initialValue,
    };
    if (onComplete) {
        modalProps.onSubmit = handleSubmit;
        modalProps.onSubmitValue = handleSubmitValue;
    }
    return {
        /** Call this to open the modal with a specific value */
        openModal: useCallback((value) => {
            setState({ value, initialValue: value, open: true });
            return new Promise((resolve) => {
                resolveRef.current = resolve;
            });
        }, []),
        /** Call this to close the modal */
        closeModal: handleClose,
        /** Pass these props directly to the Modal element */
        modalProps,
    };
}
//# sourceMappingURL=useModalProps.js.map